import { useState } from "react";
import { createPortal } from "react-dom";
function useValidationToast(){
  const [msg,setMsg]=useState(null);
  const show=(missing)=>{setMsg(missing);setTimeout(()=>setMsg(null),4000);};
  const Toast=msg?createPortal(<div style={{position:"fixed",top:16,left:"50%",transform:"translateX(-50%)",zIndex:99999,padding:"10px 20px",background:"var(--red,#FF3B30)",color:"white",borderRadius:14,fontSize:13,fontWeight:600,boxShadow:"0 6px 24px rgba(0,0,0,.2)",maxWidth:"90vw",textAlign:"center",animation:"fadeIn .2s"}}>{msg}</div>,document.body):null;
  return{show,Toast};
}
function validateFields(fields){
  const missing=fields.filter(f=>!f.ok).map(f=>f.label);
  return missing;
}
export { useValidationToast, validateFields };
